import { render, staticRenderFns } from "./RecoverVehicleListPolice.vue?vue&type=template&id=22d5ba3a"
import script from "./RecoverVehicleListPolice.vue?vue&type=script&lang=js"
export * from "./RecoverVehicleListPolice.vue?vue&type=script&lang=js"
import style0 from "./RecoverVehicleListPolice.vue?vue&type=style&index=0&id=22d5ba3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports